import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { EffectCoverflow, Navigation, Autoplay } from "swiper";
import axios from "axios";
import { toast } from "react-toastify";
import SlideComponent from "./SlideComponent";
import SlideLoadingSkeleton from "./SlideLoadingSkeleton";


const url = "https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=Cocktail";

const Slider = () => {
  const [cocktail, setCocktail] = useState([]);
  const [loading, setLoading] = useState(true);
  SwiperCore.use([EffectCoverflow, Navigation, Autoplay]);
  const getDrinks = async () => {
    setLoading(true);
    await axios
      .get(url)
      .then((res) => {
        if (res) {
          const drinks = res.data.drinks;
          // console.log(drinks);
          //   console.log(res.data);
          if (drinks) {
            const mapData = res.data?.drinks?.map((drink) => {
              const { idDrink: id, strDrink: name, strDrinkThumb: img } = drink;
              return { id, img, name };
            });
            //   console.log(mapData);
            setCocktail(mapData);
            setLoading(false);
          } else {
            toast.warn("data missing!", {
              position: "top-center",
              autoClose: 2000,
            });
            setCocktail([]);
          }
        } else {
          toast.warn("data not found!", {
            position: "top-center",
            autoClose: 2000,
          });
          setCocktail([]);
        }
        //   console.log(res.data.drinks);
      })
      .catch((err) => {
        console.log(err);
        toast.warn("Error occured when trying to fetch slide data!", {
          position: "top-center",
          autoClose: 5000,
        });
      });
  };
  useEffect(() => {
    getDrinks();
  }, []);
//   console.log(cocktail);

  if (loading) {
    return <SlideLoadingSkeleton />;
  }
  return (
    <section className="slider-bg">
      <h1 className="text-white text-[20px] text-center title-slide mb-1">
        Most Searched Drinks
      </h1>
      <div className="w-[100px] h-1 bg-[#ffffff] mx-auto mb-2 rounded-lg"></div>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          spaceBetween={30}
          loop={true}
          loopfillgroupwithblank="true"
          modules={[EffectCoverflow, Navigation]}
          navigation={true}
          autoplay={{ delay: 5000 }}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          className="mySwiper"
          breakpoints={{
            350: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
        >
          {cocktail.length !== 0 ? (
            cocktail?.map((item) => {
              const { id } = item;
              return (
                <SwiperSlide key={id}>
                  <SlideComponent {...item} />
                </SwiperSlide>
              );
            })
          ) : (
            <>
            <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-1.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-2.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </SwiperSlide>
            </>
           )}
        </Swiper>
    </section>
  );
};

export default Slider;
